var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.3 28.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    d: "M15.5,28.3c4.4,0,8.4-2,11-5.2c1.6-1.9-0.1-4.7-2.6-4.3c-4.6,0.9-8.8-2.6-8.8-7.2c0-2.7,1.4-5.1,3.7-6.4 C21,3.9,20.5,0.7,18,0.2C17.2,0.1,16.3,0,15.5,0C7.6,0,1.3,6.3,1.3,14.2C1.3,22,7.6,28.3,15.5,28.3z M15.5,2.7 c0.7,0,1.4,0.1,2.1,0.2c-3,1.7-5.1,5-5.1,8.7c0,6.3,5.7,11,11.9,9.9c-2.1,2.6-5.3,4.3-8.9,4.3c-6.4,0-11.5-5.2-11.5-11.5 S9.1,2.7,15.5,2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMoon);
export default __webpack_public_path__ + "static/media/light-moon.3e5c8806eef4b172f41d98d41b1bf700.svg";
export { ForwardRef as ReactComponent };